/*
  ULTREIA v16.9 — la librería sigue sola (sections/main-collection-product-grid).

  Cuando el final de la grilla se acerca a la pantalla, se pide la página
  siguiente de la misma colección (con los filtros y el orden que haya),
  dibujada solo por esta sección (Section Rendering API), y sus tarjetas se
  suman a la grilla. La paginación numerada queda en el HTML: sin JS, o si
  algo falla, sigue andando como antes.

  facets.js de Dawn reemplaza el contenido de #ProductGridContainer al
  filtrar u ordenar: un MutationObserver vuelve a engancharse al nuevo final.

  ponytail: no reescribe la URL; al volver atrás desde un libro, el
  navegador vuelve a la primera tanda. Agregar history.replaceState con
  ?page=N si se nota.
*/
(function () {
  'use strict';
  if (!window.fetch) return;

  /* Se mira en cada scroll (una vez por cuadro) si el final ya está a menos
     de 900 px de la pantalla, o si quedó arriba: un salto con la tecla Fin
     lo pasa de largo y un IntersectionObserver no se entera. */
  var marcas = [], pendiente = false;
  function revisar() {
    pendiente = false;
    marcas = marcas.filter(function (m) { return m.isConnected && !m.dataset.uPidiendo; });
    marcas.forEach(function (m) { if (m.getBoundingClientRect().top < window.innerHeight + 900) traer(m); });
  }
  function pedir() { if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); } }
  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', pedir);

  function traer(marca) {
    if (marca.dataset.uPidiendo) return;
    marca.dataset.uPidiendo = '1';
    var grilla = document.getElementById('product-grid');
    var paginas = marca.closest('.u-paginas');
    var estado = paginas && paginas.querySelector('[data-u-mas-estado]');
    if (!grilla || !paginas) return;
    paginas.classList.add('is-trayendo');
    if (estado) estado.textContent = 'Trayendo más libros…';
    var url = marca.getAttribute('data-u-mas');
    fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + grilla.getAttribute('data-id'))
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        var nuevas = doc.querySelector('.u-paginas');
        [].forEach.call(items, function (li) { grilla.appendChild(document.importNode(li, true)); });
        if (nuevas) {
          nuevas = document.importNode(nuevas, true);
          paginas.replaceWith(nuevas);
          var e2 = nuevas.querySelector('[data-u-mas-estado]');
          if (e2) e2.textContent = items.length + ' libros más.';
          enganchar(nuevas);
        } else {
          paginas.remove();
        }
      })
      .catch(function () {
        // Si falla, queda la paginación de siempre a la vista.
        paginas.classList.remove('is-continua', 'is-trayendo');
        if (estado) estado.textContent = '';
      });
  }

  function enganchar(raiz) {
    [].forEach.call((raiz || document).querySelectorAll('.u-paginas'), function (p) {
      var marca = p.querySelector('[data-u-mas]');
      if (!marca) { p.classList.remove('is-continua'); return; }
      p.classList.add('is-continua');
      // Sin pedir() acá: la tanda siguiente espera a que la persona siga
      // bajando. Si no, parada en el pie de página se encadenaban todas.
      marcas.push(marca);
    });
  }

  function arrancar() {
    // Sin "scroll anchoring": al sumar libros, el navegador corría la página
    // para dejar el pie a la vista, eso contaba como scroll y se pedía otra
    // tanda, y otra. Así, quien estaba abajo ve directamente los libros nuevos.
    if (document.querySelector('[data-u-mas]')) { document.documentElement.style.overflowAnchor = 'none'; document.body.style.overflowAnchor = 'none'; }
    enganchar(document);
    pedir();
    var cont = document.getElementById('ProductGridContainer');
    if (cont && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var p = cont.querySelector('.u-paginas:not(.is-continua)');
        if (p) enganchar(cont);
      }).observe(cont, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
